import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { setLightness } from 'polished';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { SIDEBAR_GAME_TAB, SIDEBAR_PLAY_TAB } from '../constants/sidebar';
import { COLOR_THEME } from '../utils/themer';
import GameFilterPane from './GameFilterPane';
import PlayFilterPane from './PlayFilterPane';
import { WHITE } from '../constants/colors';
import { changeSelectedTab } from '../state/sidebar';

const FilterPaneTabs = styled.div`
  display: flex;
  border-bottom: 2px solid ${COLOR_THEME.secondary};
`;

const FilterPaneHeadline = styled.h1`
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  padding: 20px;
`;

const FilterPaneTab = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  padding: 20px 0px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;

  & span {
    display: inline-block;
    padding-bottom: 4px;
    border-bottom: ${props => (props.selectedTab ? `2px solid ${COLOR_THEME.secondary}` : '')};
    color: ${props => (!props.selectedTab ? setLightness(0.65, WHITE) : '')};
  }
`;

class FilterPane extends PureComponent {
  render() {
    const {
      selectedTab, toggleDisabled, changeSelectedTab: changeTab, t,
    } = this.props;
    return (
      <React.Fragment>
        <FilterPaneTabs>
          <FilterPaneTab
            onClick={changeTab.bind(null, SIDEBAR_GAME_TAB)}
            selectedTab={selectedTab === SIDEBAR_GAME_TAB}
          >
            <span id="Sidebar.Tabs.Game">{t('Sidebar.Tabs.Game')}</span>
          </FilterPaneTab>
          {!toggleDisabled && (
            <FilterPaneTab
              onClick={changeTab.bind(null, SIDEBAR_PLAY_TAB)}
              selectedTab={selectedTab === SIDEBAR_PLAY_TAB}
            >
              <span id="Sidebar.Tabs.Play">{t('Sidebar.Tabs.Play')}</span>
            </FilterPaneTab>
          )}
        </FilterPaneTabs>
        <FilterPaneHeadline>{t('Sidebar.Headline')}</FilterPaneHeadline>
        {selectedTab === SIDEBAR_GAME_TAB ? <GameFilterPane /> : <PlayFilterPane />}
      </React.Fragment>
    );
  }
}

FilterPane.propTypes = {
  selectedTab: PropTypes.string.isRequired, // supplied from Redux
  changeSelectedTab: PropTypes.func.isRequired, // supplied from Redux
  t: PropTypes.func.isRequired, // supplied from withTranslation
  toggleDisabled: PropTypes.bool.isRequired, // supplied from Redux
};

const mapStateToProps = state => ({
  selectedTab: state.sidebar.selectedTab,
  toggleDisabled: state.sidebar.toggleDisabled,
});

const mapDispatchToProps = {
  changeSelectedTab,
};

const TranslatedComponent = withTranslation()(FilterPane);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranslatedComponent);
